import { gql } from '@apollo/client'

export default gql(`
    mutation createRole($name: String!, $project: String) {
        createRole(
            input: {
                name: $name
            },
            project: $project
        ) {
            id
            name
            usedCount
            source
        }
    }`
)
